export * from './user.service';
import { UserService } from './user.service';
export const APIS = [UserService];
